<template>
  <div>
    <Ibox :titulo="'Filtros'">
      <FormGroup
        cols="4"
        label="Habilitado">
        <v-select 
          v-model="habilitado" 
          :clearable=false
          :options="[{v:'S',label:'Si'},{v:'N',label:'No'}]" 
          :reduce="habilitado=>habilitado.v">
        </v-select>
      </FormGroup>
      <b-col cols="12">
        <b-button 
          variant="primary" 
          style="float:right" 
          v-on:click="cargarDatos()">Cargar
        </b-button>
      </b-col>
    </Ibox>
    <Ibox :titulo="'Clientes'">
      <b-col cols="12">
        <DataTable
          :loading="loading"
          :columns="columns"
          :rows="rows"
          clases="table-bordered table-hover table-condensed nowrap">
          <div slot="table-actions">
            <router-link 
              class="btn btn-primary btn-sm" 
              tag="button" 
              :to="{ name: 'cliente/agregar' }">Agregar cliente
            </router-link>
        </div>
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'action'">
            <router-link :to="{ name: 'cliente/editar', params: { cliente:utils.je64(props.row) } }">Editar</router-link>
            | 
            <router-link :to="{ name: 'cliente/logo', params: { cliente:utils.je64(props.row) } }">Logo</router-link>
            | 
            <router-link :to="{ name: 'cliente/configuracion', params: { cliente:utils.je64(props.row) } }">Configuración</router-link>
          </span>
          <span v-else>
            {{props.formattedRow[props.column.field]}}
          </span>
        </template>
        </DataTable>
      </b-col>
    </Ibox>
  </div>
</template>

<script>
import { clienteService } from '@/services';
import {utils} from "@/helpers";

export default {
  name: 'Clientes', 
  data(){
    return {
      utils,
      loading: true,
      habilitado:'S',
      columns:[
        {label: 'Nombre', field: 'nombre'},
        {label: 'Correo', field: 'correo'},
        {label: 'Usuarios máximos', field: 'usuarios'},
        {label: 'Usuarios trabajdor máximos', field: 'usuarios_trabajador'},
        {label: 'Habilitado', field: 'desc_habilitado'},
        {label: 'Acciones', field: 'action'}
        ],
      rows:[],
    }
  },
  mounted () {
    this.cargarDatos();
  },
  methods : {
    cargarDatos(){
      this.loading = true;

      clienteService.getCliente({
        id_cliente:-1,
        habilitado:this.habilitado
      }).then(data => {
        this.rows = data.data;

        this.loading = false;
      });
    },
  }
}
</script>

<style scoped>
</style>
